import { mq } from '@styles/vars/media-queries.style'
import styled from 'styled-components'

export const RegulatoryNewsMain = styled.div``

export const IframeContainer = styled.div`
  position: relative;
  iframe {
    height: 2100px;
    ${mq.tabletP} {
      height: 1200px;
    }
  }
`
export const ChangeTabLink = styled.u`
  cursor: pointer;
`